import { NSARouterMakerResult } from 'namirasoft-account-react';
import { LogLayout } from '../LogLayout';
import { LogEntities } from '../LogEntities';
import { LogProps } from '../LogProps';
import { NSCCostChart } from 'namirasoft-cost-react';

interface LogGroupListPageProps extends NSARouterMakerResult, LogProps
{ }

function LogGroupListPage(props: LogGroupListPageProps) 
{
	return (
		<LogLayout {...props}
			action={{
				title: "",
				description: "Here you can view all the Log Groups associated with your account. This list helps you track how logs are separated, check activity levels, and manage each group individually.",
				menus: {}
			}}
			pages={{
				entity: LogEntities.log_group(props),
				list: {
					ui: {
						tab_page_view: {
							tabs: {
								extra: {
									after_history: [
										NSCCostChart.getTab(props)
									]
								}
							}
						}
					}
				}
			}}
		>
			<></>
		</LogLayout >
	);
}

export default LogGroupListPage;